const inputProps = [
  'autoComplete',
  'autoFocus',
  'form',
  'name',
  'required',
  'tabIndex',
  'id'
]
/**
 * Generate attributes only keeping generic HTML attributes and ones specified in defaults.
 *
 * @param {Object<string, any>} props
 * @param {Object<string, any>} defaults
 * @returns {Object<string, any>}
 */
export default function elementAttributes (props, defaults) {
  return Object.keys(props)
    .filter(
      key =>
        inputProps.indexOf(key) !== -1 ||
        key.slice(0, 5) === 'aria-' ||
        key.slice(0, 5) === 'data-'
    )
    .reduce(
      (newProps, key) => Object.assign({}, newProps, { [key]: props[key] }),
      defaults
    )
}
